import React from 'react'

interface StepBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  step: number
  totalSteps?: number
}

export const StepBadge = React.forwardRef<HTMLDivElement, StepBadgeProps>(
  ({ step, totalSteps = 4, className = '', ...props }, ref) => {
    const label = `Step ${step} of ${totalSteps}`
    return (
      <div
        ref={ref}
        className={`inline-flex self-start px-2.5 py-1 rounded-[4px] border border-brand-cyan/20 bg-brand-cyan/10 text-brand-cyan text-xs font-semibold tracking-wide ${className}`}
        aria-label={label}
        {...props}
      >
        {label}
      </div>
    )
  },
)

StepBadge.displayName = 'StepBadge'
